import { render, staticRenderFns } from "./explain-results-row.component.vue?vue&type=template&id=c0f0b3b6&scoped=true"
import script from "./explain-results-row.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-row.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-row.component.vue?vue&type=style&index=0&id=c0f0b3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f0b3b6",
  null
  
)

export default component.exports